/**
 * Имя файла из заголовка `Content-Disposition` ответа — для бинарных выгрузок, где имя задаёт
 * бэк (файлы 1С, персональный прайс). Разбирает `filename*=UTF-8''…` (RFC 5987, приоритетнее) и
 * обычный `filename="…"`.
 *
 * Кросс-доменно браузер отдаёт этот заголовок скрипту, только если бэк перечислил его в
 * `Access-Control-Expose-Headers` (`BE-160`). Нет заголовка или он скрыт — `null`, и потребитель
 * берёт имя файла по контракту ручки.
 */
export function contentDispositionFilename(header: string | null | undefined): string | null {
  if (!header) return null

  const extended = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/i.exec(header)
  if (extended?.[1] !== undefined) {
    try {
      return decodeURIComponent(extended[1].trim())
    } catch {
      /* битая процентная кодировка — пробуем обычный filename ниже */
    }
  }

  const quoted = /filename\s*=\s*"([^"]+)"/i.exec(header)
  if (quoted?.[1] !== undefined) return quoted[1]

  const bare = /filename\s*=\s*([^;]+)/i.exec(header)
  return bare?.[1] !== undefined ? bare[1].trim() : null
}
